import React from 'react';
import styled from 'react-emotion';
import BreadcrumbsComponent from '@jetshop/ui/Breadcrumbs';

const StyledBreadcrumbs = styled(BreadcrumbsComponent)`
  width: 100%;
  flex: 1 1 auto;
  li,
  a {
    color: #662d91;
    font-size: ${({ theme }) => theme.fontSize.breadCrumb};
  }
  margin-bottom: 10px;
`;

const Breadcrumbs = ({ breadcrumbText, parents }) => {
  const props = {
    breadcrumbText: breadcrumbText || ' ',
    parents: parents || []
  };

  return <StyledBreadcrumbs {...props} />;
};

export default Breadcrumbs;
